/* The Pro image gallery retains native zoom; the full film is a separate player. */
(() => {
  const galleryName = 'ac-pro-product-gallery';
  customElements.whenDefined('product-gallery').then(() => {
    if (customElements.get(galleryName)) return;
    const NativeGallery = customElements.get('product-gallery');
    class AcProProductGallery extends NativeGallery {
      _onVariantChanged(event) {
        const variant = event.detail.variant;
        if (!variant?.featured_media) return;
        if (event.detail.previousVariant?.featured_media?.id === variant.featured_media.id) return;
        // Original Shopify positions may include videos excluded from this image-only
        // gallery. Select the retained media ID without altering native zoom or dots.
        this._carousels.forEach(carousel => {
          const index = carousel.items.findIndex(slide =>
            slide.getAttribute('data-media-id') === String(variant.featured_media.id)
          );
          if (index >= 0) carousel.select(index, { animate: false });
        });
      }
    }
    customElements.define(galleryName, AcProProductGallery);
  });

  const playerName = 'ac-pro-film-player';
  if (customElements.get(playerName)) return;
  class AcProFilmPlayer extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._video = this.querySelector('video');
      this._button = this.querySelector('.ac-pro-film-player__toggle');
      this._fallback = this.querySelector('.ac-pro-film-player__fallback');
      if (!this._video || !this._button || !this._fallback) return;
      this._video.controls = false;
      this._button.hidden = false;
      this._fallback.hidden = true;
      this._sync();
      this._button.addEventListener('click', () => {
        if (this._video.paused || this._video.ended) {
          if (this._video.ended) this._video.currentTime = 0;
          this._video.play().catch(error => {
            if (error.name !== 'AbortError') this._showFallback();
          });
        } else {
          this._video.pause();
        }
      }, options);
      this._video.addEventListener('play', () => {
        // Keep muted explanation loops independent. Only stop other audible media.
        document.querySelectorAll('video').forEach(other => {
          if (other !== this._video && !other.muted) other.pause();
        });
        this._sync();
      }, options);
      this._video.addEventListener('pause', () => this._sync(), options);
      this._video.addEventListener('ended', () => this._sync(), options);
      this._video.addEventListener('error', () => this._showFallback(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._video.pause();
      }, options);
      document.addEventListener('play', event => {
        if (event.target instanceof HTMLVideoElement && event.target !== this._video && !event.target.muted) {
          this._video.pause();
        }
      }, { capture: true, signal: this._abort.signal });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) this._video.pause();
        });
        this._observer.observe(this);
      }
    }

    _sync() {
      const playing = !this._video.paused && !this._video.ended;
      this.dataset.state = playing ? 'playing' : 'paused';
      this._button.setAttribute('aria-label', playing ? this._button.dataset.pauseLabel : this._button.dataset.playLabel);
    }

    _showFallback() {
      if (!this.isConnected) return;
      const moveFocus = document.activeElement === this._button;
      this._video.pause();
      this._button.hidden = true;
      this._fallback.hidden = false;
      if (moveFocus) this._fallback.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._video?.pause();
    }
  }
  customElements.define(playerName, AcProFilmPlayer);
})();
